<template>
  <div class="activityData">
    <el-tabs v-model="activeName">
      <el-tab-pane label="活动资料" name="first"></el-tab-pane>
    </el-tabs>
    <el-card shadow="never">
      <h2>银联营销商户信息</h2>
      <el-form ref="form" :model="form" label-width="140px" label-position="left" class="infoForm">
        <el-form-item label="商户号">
          <el-input class="form-input" v-model="form.fMerchantId" disabled></el-input>
        </el-form-item>
        <el-form-item label="银联商编">
          <el-input class="form-input" v-model="form.fAgentId" disabled></el-input>
        </el-form-item>
        <el-form-item label="银联营销商户号">
          <el-input class="form-input" v-model="form.fBindUnionMchId" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div class="flex">
        <h2>照片信息</h2>
        <div class="mid">*商户证照信息，店内环境照等商户进件必传资料，请在【商户管理--所有商户--编辑】功能中进行查看与修改</div>
      </div>
      <el-form label-width="0" ref="picForm" :model="picForm">
        <div class="photos-content-view">
          <el-form-item label="">
            <upload-img-ele
              label="门头照"
              :value="picForm.unionpayDoorPhoto"
              :required="false"
              valueName="unionpayDoorPhoto"
              @upload="uploadSuccess"
              iconType="el-icon-picture"
              desc="（含商户店名，银联标准门贴）">
            </upload-img-ele>
          </el-form-item>
          <el-form-item label="">
            <upload-img-ele
              label="收银台照"
              :value="picForm.unionpayCashier"
              :required="false"
              valueName="unionpayCashier"
              @upload="uploadSuccess"
              iconType="el-icon-picture"
              desc="（有银联标识的收银贴及收银台卡）">
            </upload-img-ele>
          </el-form-item>
          <el-form-item label="">
            <upload-img-ele
              label="轻型设备"
              :value="picForm.unionpayLightEquipment"
              :required="false"
              valueName="unionpayLightEquipment"
              @upload="uploadSuccess"
              iconType="el-icon-picture"
              desc="（具有符合银联品牌规范logo的语音播报设备）">
            </upload-img-ele>
          </el-form-item>
          <el-form-item label="">
            <upload-img-ele
              label="播报设备"
              :value="picForm.unionpayVoiceEquipment"
              :required="false"
              valueName="unionpayVoiceEquipment"
              @upload="uploadSuccess"
              iconType="el-icon-picture"
              desc="（具有符合银联品牌规范logo的语音播报设备）">
            </upload-img-ele>
          </el-form-item>
        </div>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import uploadImgEle from '@/components/upload/uploadImgEle'
import qs from 'qs'
import { unionActivityUpdateInfo } from '@/api/activity'

export default {
  components: {
    uploadImgEle
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (Object.keys(to.query).length > 0) {
        vm.form = to.query
      } else {
        vm.form = JSON.parse(localStorage.getItem('activeForm'))
      }
      vm.picForm = Object.assign(vm.picForm, JSON.parse(localStorage.getItem('picForm')))
    })
  },
  data () {
    return {
      activeName: 'first',
      form: {},
      picForm: {
        unionpayDoorPhoto: '',
        unionpayCashier: '',
        unionpayLightEquipment: '',
        unionpayVoiceEquipment: ''
      }
    }
  },
  created () {
    this.form = this.$route.query
  },
  methods: {
    uploadSuccess (data) {
      if (data.error_code === '0') {
        const name = data.valueName
        this.picForm[name] = data.path
        this.submit()
      } else {
        this.$message({
          showClose: true,
          message: data.error_msg,
          type: 'error'
        })
      }
    },
    submit () {
      let param = Object.assign({ merchantId: this.form.fMerchantId }, this.picForm)
      this.formatParams(param)
      param = qs.stringify(param)
      unionActivityUpdateInfo(param).then(data => {
        if (data.error_code === '0') {
          this.$message({
            showClose: true,
            message: '照片提交成功',
            type: 'success'
          })
        } else {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
         * @description 删除提交参数中的空字段
         * @param {Object} params 搜索内容对象
         */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    .activityData {
        padding:0 20px
    }
    .form-input {
        width: 450px;
    }
    .flex {
        display:flex
    }
    .mid {
        height:66px;
        line-height:66px;
        margin-left:10px
    }
    .photos-content-view {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
    }
    .photos-content-view .el-form-item{
        margin-right: 40px;
        width: 200px;
        text-align: center;
    }
    .tableCard {
        margin-bottom:20px;
        border-radius: 10px 10px 0px 0px;
    }
  .tableCard .el-card__body {
    padding:0
  }
</style>
<style>
    .el-tabs__item.is-active {
        font-size: 18px;
    }
    h2 {
        margin:10px 10px 20px 0px;
    }
</style>
